import {
  Icon,
  AlertWarningIcon,
  BoxArrowUpIcon,
  ClipboardIcon,
  ClockIcon,
  HammerIcon,
  HardHatIcon,
} from '@adsk/alloy-react-icon';

import { TaskStatus, TaskSubType } from '../../../types';

export const TASK_SUB_TYPE_ICONS: Record<TaskSubType, typeof Icon> = {
  [TaskSubType.WORK]: HammerIcon,
  [TaskSubType.DELIVERY]: BoxArrowUpIcon,
  [TaskSubType.INSPECTION]: ClipboardIcon,
  [TaskSubType.ROADBLOCK]: AlertWarningIcon,
  [TaskSubType.SAFETY]: HardHatIcon,
  [TaskSubType.DOWNTIME]: ClockIcon,
};

export const DEFAULT_TASK_STATUS = TaskStatus.OPEN;
